export default __webpack_public_path__ + "static/media/blog-paver-walkway-005.b2918c8f.jpg";